import { useRouter } from 'next/router';
import React from 'react';
import {
  convertToQuery,
  createRippleEffectRelative,
  getPathForBabyNames,
} from '../../../../Utils/helper';
import { clickedCtaEvent } from '../../instrumentation/instrumentation';
import { FindBtn } from './styled';

export default function FindButton(props) {
  const { name, gender, detailPage } = props;
  const router = useRouter();
  const { query } = useRouter();
  const findName = () => {
    query.page = 1;
    let obj = {
      ...query,
      startingWith: name.current,
      gender: gender.current,
    };
    let qs = convertToQuery(obj);
    clickedCtaEvent(true, 'Search By', 'Find A Name');

    router.push(getPathForBabyNames('search?', detailPage, '') + qs);
  };
  return (
    <FindBtn
      id="findName"
      onClick={(event) => {
        createRippleEffectRelative(event, document.getElementById('findName'));
        findName();
      }}
      // onClick={() => findName()}
    >
      Find A Name
    </FindBtn>
  );
}
